import { cn } from '@/lib/utils';
import { FC } from 'react';
import { paCardClass } from '../PerformanceAudienceComponents';

const SkeletonBlock: FC<{ className?: string }> = ({ className }) => (
  <div
    className={cn(
      'animate-ar-skel rounded-lg bg-[linear-gradient(90deg,var(--ink-100)_0%,var(--ink-50)_50%,var(--ink-100)_100%)] bg-[length:200%_100%]',
      className
    )}
  />
);

export const PerformanceDashboardSkeleton: FC = () => {
  return (
    <div className='flex flex-col gap-[18px]' aria-busy='true' aria-live='polite'>
      <SkeletonBlock className='h-11 rounded-[10px]' />

      <div className='grid grid-cols-2 gap-[18px] xl:grid-cols-4'>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className='min-h-[110px] rounded-[14px] border border-ink-150 bg-white px-5 py-[18px]'>
            <SkeletonBlock className='mb-3.5 h-3 w-[55%]' />
            <SkeletonBlock className='mb-3 h-7 w-[40%]' />
            <SkeletonBlock className='h-2.5 w-[70%]' />
          </div>
        ))}
      </div>

      <div className='grid grid-cols-1 gap-[18px] xl:grid-cols-[1.4fr_1fr]'>
        <div className={cn(paCardClass, 'min-h-[280px]')}>
          <SkeletonBlock className='mb-2 h-3.5 w-[45%]' />
          <SkeletonBlock className='mb-[18px] h-2.5 w-[65%]' />
          <SkeletonBlock className='h-[220px] w-full' />
        </div>
        <div className={cn(paCardClass, 'min-h-[280px]')}>
          <SkeletonBlock className='mb-2 h-3.5 w-1/2' />
          <SkeletonBlock className='mb-[18px] h-2.5 w-2/5' />
          {Array.from({ length: 6 }).map((_, index) => (
            <SkeletonBlock key={index} className='mb-2 h-7 w-full' />
          ))}
        </div>
      </div>

      <div className={cn(paCardClass, 'min-h-[280px]')}>
        <SkeletonBlock className='mb-2 h-3.5 w-[35%]' />
        <SkeletonBlock className='mb-[18px] h-2.5 w-1/2' />
        <SkeletonBlock className='h-9 w-[30%]' />
      </div>
    </div>
  );
};
